import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('PAYMENT_CONCEPT', ['FORM'])
